import { memo } from 'react';
import { PERIOD1_COLOR, PERIOD2_COLOR, PERIOD_DOT_SIZE_DEFAULT } from '../constants/comparisonConstants';

/**
 * Componente reutilizável para exibir uma bolinha colorida indicando o período
 * 
 * @param {Object} props
 * @param {number} props.period - Número do período (1 ou 2)
 * @param {number} [props.size=8] - Tamanho da bolinha em pixels
 * @param {boolean} [props.showBorder=true] - Se deve exibir borda branca
 * @param {boolean} [props.showShadow=true] - Se deve exibir sombra
 * @param {string} [props.className] - Classe CSS adicional
 * @param {Object} [props.style] - Estilos inline adicionais
 */
const PeriodDot = memo(({ 
    period, 
    size = PERIOD_DOT_SIZE_DEFAULT, 
    showBorder = true, 
    showShadow = true,
    className = '',
    style = {}
}) => {
    if (!period || (period !== 1 && period !== 2)) {
        return null;
    }

    const periodColor = period === 1 ? PERIOD1_COLOR : PERIOD2_COLOR;

    return (
        <span
            className={className}
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: periodColor,
                border: showBorder ? '1px solid #fff' : 'none',
                boxShadow: showShadow ? '0 1px 2px rgba(0,0,0,0.2)' : 'none',
                display: 'inline-block',
                flexShrink: 0,
                ...style
            }}
            aria-label={`Período ${period}`}
            role="img"
        />
    );
});

PeriodDot.displayName = 'PeriodDot';

export default PeriodDot;
